/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPoll} from '@fortawesome/pro-duotone-svg-icons';

const PdCourseSurveysIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPoll} {...props} />
);

export default PdCourseSurveysIcon;
